import React from "react";
import { IAgency, IAgencyAddress } from "models";

import "./AgencyGrid.scss";
import { dataTestIds } from "data-testids";

export interface IAgencyGridProps {
  model: IAgency;
}

const SEQUENCE: (keyof Partial<IAgency>)[] = ["name", "email"];

export const AgencyGrid: React.FC<
  React.PropsWithChildren<IAgencyGridProps>
> = ({ model }) => {
  const getAddress = (address: IAgencyAddress) => {
    const nameParts = [
      address.addressLine1,
      address.addressLine2,
      address.addressLine3,
      address.addressLine4,
      address.country,
      address.postCode,
    ];

    return nameParts.filter((item) => Boolean(item)).join(", ");
  };

  const elements = SEQUENCE.map(
    (field) =>
      model[field] && (
        <div key={field.toString()} className="c-agency-grid__cell">
          {/* @ts-expect-error - type it */}
          {field === "address"
            ? getAddress(model[field] as IAgencyAddress)
            : model[field]}
        </div>
      )
  ).filter(Boolean);

  return (
    <div
      className="c-agency-grid"
      data-testid={dataTestIds.profile["ManageContactsPage.AgencyDetails.row"]}
    >
      {elements}
    </div>
  );
};
